module.exports = __webpack_public_path__ + "img/glasses-8-4.d858b0a1.svg";